import { CardContainer } from "./CardContainer"
import { CardStat } from "./CardComps"
import dayjs from "dayjs"

const EventListCard = ({ data }) => (
  <CardContainer
    disableEditDelete
    SummaryContent={
      <>
        <CardStat
          label="Admission Date"
          value={
            data?.admissionDate
              ? dayjs(data.admissionDate).format("DD-MM-YYYY")
              : "N/A"
          }
        />
        <CardStat label="Academic Year" value={data?.academicYear} />
        <CardStat label="Status" value={data?.status} />
      </>
    }
  />
)

export default EventListCard
